// import { post, get, put, patch, remove, file } from './utils';
import { get, post, file } from './utils';

export default {
  login: key => post(`/login`, { key }),

  getEntries: (species, genes, sequence) => post(`/entries`, { species, genes, sequence }),
  getGenes: species => get(`/genes/${species}`),

  download: filename => file(`/download/${filename}`)
};
